import { useEffect, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { FHTimer, FProgressBar } from '../../../../../../components/base';
import { FORTA_SUCCESS } from '../../../../../../utils/colors';
import { DESKTOP_MOBILE_CAPTURE_DOCUMENT_POLL_INTERVAL_SECONDS } from '../constants';

import type { DesktopMobileCapturePollingNoticeProps } from './types';

export default function DesktopMobileCapturePollingNotice({
  isRefreshing,
}: DesktopMobileCapturePollingNoticeProps) {
  const [timerKey, setTimerKey] = useState(0);

  useEffect(() => {
    if (!isRefreshing) {
      setTimerKey((previousKey) => previousKey + 1);
    }
  }, [isRefreshing]);

  return (
    <Stack alignItems="center" direction="row" flexWrap="wrap" gap={0.5}>
      <Typography variant="body2">{`Mobile uploads refresh every ${DESKTOP_MOBILE_CAPTURE_DOCUMENT_POLL_INTERVAL_SECONDS} seconds. Next refresh in`}</Typography>
      {isRefreshing ? (
        <Box sx={{ flexGrow: 1, maxWidth: 120, minWidth: 80, mt: 0.5 }}>
          <FProgressBar sx={{ position: 'static', width: '100%', zIndex: 0 }} />
        </Box>
      ) : (
        <FHTimer
          duration={DESKTOP_MOBILE_CAPTURE_DOCUMENT_POLL_INTERVAL_SECONDS}
          key={timerKey}
          sx={{ color: FORTA_SUCCESS, fontWeight: 'bold' }}
        />
      )}
    </Stack>
  );
}
